export class RepresentadaModel {

    REP_CODIGO?: string;
    REP_NOME?: string;
    REP_RAZAO?: string;
    REP_EMAIL?: string;
    REP_SITE?: string;
    REP_FONE?: string;
    REP_LOGO?: string;

    constructor () {
        
        this.REP_CODIGO = '';
        this.REP_NOME = '';
        this.REP_RAZAO = '';
        this.REP_EMAIL = '';
        this.REP_SITE = '';
        this.REP_FONE = '';
        this.REP_LOGO = '';
            
    }

}



// WEBPACK FOOTER //
// ./src/models/representada-model.ts